import PropTypes from 'prop-types';
import React, { Component } from 'react';
import {
  ButtonToolbar,
  ButtonGroup,
  Button,
} from 'react-bootstrap';
import TourFilterDropDown from './TourFilterDropDown';

class TourListToolbar extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <ButtonToolbar>
        { !this.props.isTourManager && (
        <ButtonGroup>
          <Button
            onClick={this.props.handleAddTour}
            bsStyle="success"
          >
            + Add Travel
          </Button>
        </ButtonGroup>
        )}
        <ButtonGroup>
          <TourFilterDropDown
            filter={this.props.filter}
            tourFilterSet={this.props.tourFilterSet}
          />
        </ButtonGroup>
      </ButtonToolbar>
    );
  }
}
TourListToolbar.propTypes = {
  isTourManager: PropTypes.bool.isRequired,
  filter: PropTypes.object,
  tourFilterSet: PropTypes.func.isRequired,
  handleAddTour: PropTypes.func.isRequired,
};
TourListToolbar.defaultProps = {
  filter: {},
};

export default TourListToolbar;



// WEBPACK FOOTER //
// src/routes/tours/components/TourListToolbar.js